import {
  Category,
  ParentCategory,
  Group,
  Categories,
  FORUM_TYPE
} from '.'

// eslint-disable-next-line import/no-internal-modules
import { GroupedItemsList, Item } from '@insided/deprecated-preact-components/dropdown/interfaces'

export function getParentCategories(categories: Categories): ParentCategory[] {
  return categories.filter((category) => {
    const isParentCategory = category.type === FORUM_TYPE.COMMUNITY || category.type === FORUM_TYPE.KNOWLEDGE_BASE
    const hasCategories = 'categories' in category
    return isParentCategory && hasCategories
  })
}

export function getGroups(categories: Categories): Group[] {
  return categories.filter((category) => {
    return (
      category.type === FORUM_TYPE.PUBLIC_GROUP ||
      category.type === FORUM_TYPE.PRIVATE_GROUP ||
      category.type === FORUM_TYPE.HIDDEN_GROUP
    )
  })
}

export function getItemsForCategory(categories: Category[], onUpdate: (categoryId: number) => void) {
  return categories.map(({ categoryId, categoryName }: Category) => {
    return {
      id: String(categoryId),
      title: categoryName,
      value: String(categoryId),
      onClick: () => onUpdate(categoryId)
    }
  })
}

export function getItemsForGroups(groups: Group[], onUpdate: (categoryId: number) => void) {
  return groups.map(({ groupId, groupName }: Group) => {
    return {
      id: String(groupId),
      title: groupName,
      value: String(groupId),
      onClick: () => onUpdate(groupId)
    }
  })
}

export function normalizeCategoriesAndGroups(categories: Categories, onUpdate: (categoryId: number) => void): GroupedItemsList {
  const parentCategories = getParentCategories(categories)
  const normalizedParentCategories = parentCategories.map((parentCategory) => {
    return {
      groupName: parentCategory.groupName,
      items: getItemsForCategory(parentCategory.categories as Category[], onUpdate)
    }
  })

  const groups = getGroups(categories)
  const normalizedGroups = groups.length >= 1
  ? [{
      groupName: 'Groups',
      items: getItemsForGroups(groups, onUpdate)
    }]
  : []

  return [...normalizedParentCategories, ...normalizedGroups]
}

export function getTitleForCategoryId(groupedItems: GroupedItemsList, categoryId: number | null) {
  if (!categoryId) {
    return 'Select category'
  }
  const category = groupedItems.find(groupedItem => {
    return groupedItem.items.find((item: Item) => item.id === String(categoryId))
  })
  const item = category?.items.find((item: Item) => item.id === String(categoryId))
  return item?.title
}
